import { FCX } from "@datassential/platform-ui-lib";
import SelectFilters from "@vms/SelectFilters";
import { memo } from "react";
import SelectViewAs from "@pages/Home/components/HomeHeader/SelectViewAs";
import { useSelectedKeywordsContext } from "@vms/SelectedKeywords/SelectedKeywordsContext";
import { useHomeSearchSettingsContext } from "@pages/Home/HomeContext";

const HomeHeaderControls: FCX = ({
	children
}) => {
    const { resetSearch } = useHomeSearchSettingsContext();
	const { isSelectedKeywordsView } = useSelectedKeywordsContext();
	return (
		<div className="HomeHeaderControls">
			{children}
			<SelectViewAs/>
			{!isSelectedKeywordsView && (
				<SelectFilters
					className="HomeHeaderControls__filters"
					testId="buttonHomeHeaderFilters"
                    onApply={resetSearch}
				/>
			)}
		</div>
	)
}

export default memo(HomeHeaderControls);